import { render } from "./PullToRefreshAndPagination.vue?vue&type=template&id=39b7d0a5&scoped=true"
import script from "./PullToRefreshAndPagination.vue?vue&type=script&lang=js"
export * from "./PullToRefreshAndPagination.vue?vue&type=script&lang=js"

import "./PullToRefreshAndPagination.vue?vue&type=style&index=0&id=39b7d0a5&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b7d0a5"]])

export default __exports__